module.exports = __webpack_public_path__ + "static/media/logout-exit.c3414ab6.svg";